import React from 'react'
import Services from '../../api/Services';
import { Link } from 'react-router-dom'
import ins1 from '../../images/instragram/img-1.jpg'
import ins2 from '../../images/instragram/img-2.jpg'
import ins3 from '../../images/instragram/img-3.jpg'
import ins4 from '../../images/instragram/img-4.jpg'
import ins5 from '../../images/instragram/img-4.jpg'
import ins6 from '../../images/instragram/img-6.jpg'

const ServiceSidebar = (props) => {


    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="wpo-single-sidebar" style={{ marginTop: "50px" }}>

            <div className="widget wpo-service-widget" style={{backgroundColor:"#076b9b", marginBottom:"5px"}}>
                <img src={ins1} alt="img" />
            </div>
            <p style={{fontWeight:"bold",fontSize:"13px", marginBottom:"35px"}}>Heart to Heart Children’s Aid Foundation is a U.S. nonprofit organization that is exempted from federal income tax and can receive tax-deductible donations, as defined in Section 501(c)(3) of the Internal Revenue Code.</p>


            <div className="widget wpo-service-widget">
                <h2>Our Impact So Far</h2>
                <ul>
                    <li ><Link to={'/impact'}>45% From waiting list </Link></li>
                    <li ><Link to={'/impact'}>30% Reached out directly</Link></li>
                    <li ><Link to={'/impact'}>25% Down syndrome and heart disease  </Link></li>

                </ul>
            </div>
             
            <div className="wpo-newsletter-widget widget">
                <h2>Join Our Mission</h2>
                <p>Thousands of children around the world are still waiting for their turn.</p>
                <div className='row' style={{ gap: '10px', marginLeft: '30px' }} >
                    {/* <div className='col-12'>
                        <Link onClick={ClickHandler} to="/about" className="theme-btn">Donate Now</Link>
                    </div> */}
                    <div className='col-12 text-center' >
                        <Link onClick={ClickHandler} to="/donate" className="theme-btn">Donate</Link>
                    </div>


                </div>

            </div>
            
           

        </div>

    )
}

export default ServiceSidebar;

